import React from 'react'
import PropTypes from 'prop-types'

const BoxColor = ({ color, className }) => {
  return (
    <div
      data-testid="box-color"
      className={`box-color ${className}`}
      style={{ backgroundColor: color }}
    >
      {color && <span>$</span>}
    </div>
  )
}

BoxColor.ropTypes = {
  color: PropTypes.string,
}

BoxColor.defaultProps = {
  color: '#F7FAFB',
}

export default BoxColor
